module.exports = __webpack_public_path__ + "img/notification_off.be02fc95.svg";